import { render, staticRenderFns } from "./UserGifts.vue?vue&type=template&id=38aad7de&"
import script from "./UserGifts.vue?vue&type=script&lang=js&"
export * from "./UserGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports